import {addClass, listener} from "../../../../../../../modules/vegas/js/util";
import VGCatalogCart from "./cart";

const cart = new VGCatalogCart();

// Добавляем с карточки товара
function listeners() {
	listener('click', '[data-product-item] [data-cart][data-action=add]', function (el, event) {
		event.preventDefault();

		let product = el.closest('[data-product-item]');
		if (product) {
			cart.add(product, function () {
				addClass(product, 'in-cart');
			});
		}
	});

	// Добавляем со страницы товара
	listener('click', '[data-product] [data-cart][data-action=add]', function (el, e) {
		e.preventDefault();

		let product = el.closest('[data-product]');
		if (product) {
			cart.add(product, function () {
				addClass(product, 'in-cart');
			});
		}
	});
}

document.addEventListener("DOMContentLoaded", listeners);
